<template>
  <v-card :loading="loading" flat dense>
    <v-form ref="form" v-model="valid">
      <v-card-title>
        {{ $t('ITEM.EDIT') }} {{ $t('ITEM.ITEM') }}
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <item-form
          v-model="form"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />
        <v-card-actions>
          <v-btn outlined depressed large color="grey" @click="cancel">
            {{ $t('BUTTON.CANCEL') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            large
            depressed
            color="success"
            :disabled="!valid"
            @click="edit"
          >
            {{ $t('BUTTON.SAVE') }}
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import { DocumentsListsItemsService } from '@/services/documents-lists-items.service';
import ItemForm from '@/modules/documents_lists/components/forms/ItemForm';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ItemEdit',

  components: {
    ItemForm
  },

  mixins: [errors],

  props: {
    id: {
      type: Number,
      required: true
    },
    listId: {
      type: Number,
      required: true
    }
  },

  computed: {
    ...mapGetters(['loading'])
  },

  data() {
    return {
      form: {
        type_id: null,
        children: null,
        contentable_id: null,
        translations: []
      },
      valid: true
    };
  },

  mounted() {
    DocumentsListsItemsService.getById(this.listId, this.id).then(
      data => (this.form = data.data)
    );
  },

  methods: {
    ...mapActions('snackbar', ['setSnack']),
    cancel() {
      this.$emit('cancel');
    },
    edit() {
      DocumentsListsItemsService.update(this.listId, this.form)
        .then(({ data }) => {
          this.setSnack({
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('edited', data);
        })
        .catch(this.handleErrors);
    }
  }
};
</script>
